import { ArrowUpRight, Banknote, CreditCard, Barcode } from "lucide-react";
import Reveal from "@/components/Reveal";
import { PAYMENTS, LINKS } from "@/data/content";

const ICONS = {
  banknote: { Icon: Banknote, bg: "bg-[#0055FE]" },
  card: { Icon: CreditCard, bg: "bg-[#FF5A36]" },
  boleto: { Icon: Barcode, bg: "bg-[#00B37E]" },
};

export default function Payment() {
  return (
    <section id="pagamento" data-testid="payment-conditions-section" className="bg-[#F8FAFC] text-[#0F172A] py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="font-mono text-[11px] sm:text-xs tracking-[0.35em] text-[#0055FE] mb-5">
            CONDIÇÕES DE PAGAMENTO
          </p>
          <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl max-w-2xl mx-auto">
            Sua viagem, do seu jeito.{" "}
            <em className="font-serif italic font-medium text-[#FF5A36]">O pagamento também.</em>
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-xl mx-auto">
            Para facilitar o planejamento da sua viagem, trabalhamos com diferentes formas de pagamento.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {PAYMENTS.map((p, i) => {
            const { Icon, bg } = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 0.1}>
                <div
                  data-testid={p.testid}
                  className="group h-full bg-white rounded-3xl p-8 border border-slate-200/80 shadow-[0_10px_40px_-15px_rgba(11,17,32,0.12)] hover:-translate-y-2 hover:shadow-[0_25px_60px_-15px_rgba(0,85,254,0.25)] transition-[transform,box-shadow] duration-500"
                >
                  <div className="flex items-start justify-between">
                    <span className={`inline-flex items-center justify-center w-12 h-12 rounded-2xl ${bg} text-white`}>
                      <Icon size={22} strokeWidth={2.2} />
                    </span>
                    <span className="font-display font-extrabold text-3xl text-slate-200 group-hover:text-[#0055FE] transition-colors duration-500">
                      {p.badge}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display font-semibold text-xl tracking-tight">{p.title}</h3>
                  <p className="mt-3 text-slate-600 text-base leading-relaxed">{p.description}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2} className="mt-12 text-center">
          <p className="text-sm text-slate-500 italic max-w-xl mx-auto">
            As condições de pagamento podem variar de acordo com o destino, período, fornecedores e serviços
            contratados.
          </p>
          <a
            href={LINKS.pagamento}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="payment-cta-btn"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#0B1120] text-white font-semibold px-8 py-4 hover:bg-[#0055FE] transition-colors duration-300"
          >
            Quero fazer minha cotação
            <ArrowUpRight size={18} />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
